export var AzureVaultType;
(function (AzureVaultType) {
    AzureVaultType["RecoveryServicesVault"] = "Recovery Services Vault";
    AzureVaultType["BackupVault"] = "Backup Vault";
})(AzureVaultType || (AzureVaultType = {}));
